import colorPattern from '../../colors'

const darkBorderColors = {
    'border-primary': colorPattern.pearl,
    'border-secondary': colorPattern.moon,
    'border-tertiary': colorPattern.dust,
    'border-invert': colorPattern.onyx,
    'border-brand-primary': colorPattern.cyan,
    'border-brand-secondary': colorPattern.violet,
} as const

export default darkBorderColors
